import { render, staticRenderFns } from "./ReviseRecordList.vue?vue&type=template&id=bd1bca10&scoped=true"
import script from "./ReviseRecordList.vue?vue&type=script&lang=js"
export * from "./ReviseRecordList.vue?vue&type=script&lang=js"
import style0 from "./ReviseRecordList.vue?vue&type=style&index=0&id=bd1bca10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1bca10",
  null
  
)

export default component.exports